import { NgModule } from '@angular/core';
import { FiChecklistReportTableFilterComponent } from './widget-table-filter/widget-table-filter.component';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { MatIconModule } from '@angular/material/icon';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { MatMenuModule } from '@angular/material/menu';
import { FiMenuMultiSelectItemSearchModule } from '@fi-shared/fi-menu-multi-select-item-search/fi-menu-multi-select-item-search.module';
import { MatButtonModule } from '@angular/material/button';
import { InfoIconModule } from '@fi-app/shared/info-icon/info-icon.module';
import { FiChecklistDetailsHeaderInformationComponent } from './checklist-header-information/checklist-header-information.component';
import { FiChecklistAttachmentsGalleryCard } from './checklist-attachments-gallery-card/checklist-attachments-gallery-card.component';
import { FiChecklistAttachmentsListComponent } from './checklist-attachments-list/fi-checklist-attachments-list.component';
import { FiChecklist2ReportWidgetDetailsHeader } from './checklist-report-widget-details-header/checklist-report-widget-details-header.component';
import { FiChecklistStatusRowComponent } from './checklist-status-row/checklist-status-row.component';
import { FiChecklistAttachmentDetailsDialogComponent } from './checklist-attachment-details-dialog/checklist-attachment-details-dialog.component';
import { FiItemsListFilterModule } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter.module';
import { FiMenuItemSearchModule } from '@fi-shared/fi-menu-item-search/fi-menu-item-search.module';
import { FiChecklist2ReportWidgetMenuComponent } from './fi-checklist2-report-widget-menu/fi-checklist2-report-widget-menu.component';
import { FiDatePickerModule } from '@fi-shared/fi-date-picker';
import { FiMatIconCheckboxMenuModule } from '@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module';
import { FiMenuFoldableMultiSelectItemSearchModule } from '@fi-shared/fi-menu-foldable-multi-select-item-search/fi-menu-foldable-multi-select-item-search.module';
import { ChecklistWidgetTableFilterHelperService } from '@fi-shared/checklist/fi-checklist2-report/components/shared/widget-table-filter-helper.service';
import { FiMenuExpandableMultiSelectItemSearchModule } from '@fi-shared/fi-menu-expandable-multi-select-item-search/fi-menu-expandable-multi-select-item-search.module';
import { ChecklistWidgetTableFilterDataService } from '@fi-shared/checklist/fi-checklist2-report/components/shared/widget-table-filter-data.service';
import { FiChecklist2ReportChartDescriptionComponent } from '@fi-shared/checklist/fi-checklist2-report/components/shared/fi-checklist2-report-chart-description/fi-checklist2-report-chart-description.component';
import { MatExpansionPanel, MatExpansionPanelHeader } from '@angular/material/expansion';
import { FiChecklistDetailedAnswersTableComponent } from '@fi-shared/checklist/fi-checklist2-report/components/shared/detailed-answers-table/detailed-answers-table.component';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiChecklist2ReportColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-report/fi-checklist2-report-column-defs/fi-checklist2-report-column-defs.module';
import { FiChecklist2ListColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-column-defs.module';
import { FiChartModule } from '@fi-shared/fi-chart/fi-chart.module';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        FiLocalSearch2Module,
        MatIconModule,
        FiAppTextSharedModule,
        FiAttachmentsModule,
        FiFormatDateModule,
        MatMenuModule,
        FiMenuMultiSelectItemSearchModule,
        MatButtonModule,
        InfoIconModule,
        FiItemsListFilterModule,
        FiMenuItemSearchModule,
        FiChartModule,
        FiDatePickerModule,
        FiMatIconCheckboxMenuModule,
        FiMenuFoldableMultiSelectItemSearchModule,
        FiMenuExpandableMultiSelectItemSearchModule,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        FiWrapperTableModule,
        FiChecklist2ReportColumnDefsModule,
        FiChecklist2ListColumnDefsModule,
        FiWhenScrolledModule,
    ],
    declarations: [
        FiChecklistReportTableFilterComponent,
        FiChecklistDetailsHeaderInformationComponent,
        FiChecklistAttachmentsGalleryCard,
        FiChecklistAttachmentsListComponent,
        FiChecklist2ReportWidgetDetailsHeader,
        FiChecklistStatusRowComponent,
        FiChecklistAttachmentDetailsDialogComponent,
        FiChecklist2ReportWidgetMenuComponent,
        FiChecklist2ReportChartDescriptionComponent,
        FiChecklistDetailedAnswersTableComponent,
    ],
    providers: [ChecklistWidgetTableFilterHelperService, ChecklistWidgetTableFilterDataService],
    exports: [
        FiChecklistReportTableFilterComponent,
        FiChecklistDetailsHeaderInformationComponent,
        FiChecklistAttachmentsGalleryCard,
        FiChecklistAttachmentsListComponent,
        FiChecklist2ReportWidgetDetailsHeader,
        FiChecklistStatusRowComponent,
        FiChecklist2ReportWidgetMenuComponent,
        FiChecklist2ReportChartDescriptionComponent,
        FiChecklistDetailedAnswersTableComponent,
    ],
})
export class FiChecklist2ReportSharedModule {}
